import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9e6ce18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-invoice-success" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 388 13.37",
  class: "mobile-invoice-success__top-trimmed"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1154.18,235V221.63L1145.75,232l-8.44-10.38L1128.88,232l-8.44-10.38L1112,232l-8.44-10.38L1095.14,232l-8.44-10.38L1078.27,232l-8.44-10.38L1061.4,232,1053,221.63,1044.53,232l-8.43-10.38L1027.66,232l-8.44-10.38L1010.79,232l-8.43-10.38L993.92,232l-8.43-10.38L977.05,232l-8.43-10.38L960.18,232l-8.43-10.38L943.31,232l-8.43-10.38L926.44,232,918,221.63,909.57,232l-8.43-10.38L892.7,232l-8.43-10.38L875.83,232l-8.43-10.38L859,232l-8.43-10.38L842.1,232l-8.44-10.38L825.23,232l-8.44-10.38L808.36,232l-8.44-10.38L791.49,232l-8.44-10.38L774.62,232l-8.44-10.38v12.86",
    transform: "translate(-766.18 -221.63)",
    style: {"fill":"#fff"}
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mobile-invoice-success__title" }, "سفارش شما با موفقیت انجام شد", -1))
const _hoisted_4 = { class: "mobile-invoice-success__date" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "تاریخ:", -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-invoice-success__divider" }, null, -1))
const _hoisted_8 = { class: "mobile-invoice-success__footer" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 388 13.37",
  class: "mobile-invoice-success__bottom-trimmed"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1154.18,235V221.63L1145.75,232l-8.44-10.38L1128.88,232l-8.44-10.38L1112,232l-8.44-10.38L1095.14,232l-8.44-10.38L1078.27,232l-8.44-10.38L1061.4,232,1053,221.63,1044.53,232l-8.43-10.38L1027.66,232l-8.44-10.38L1010.79,232l-8.43-10.38L993.92,232l-8.43-10.38L977.05,232l-8.43-10.38L960.18,232l-8.43-10.38L943.31,232l-8.43-10.38L926.44,232,918,221.63,909.57,232l-8.43-10.38L892.7,232l-8.43-10.38L875.83,232l-8.43-10.38L859,232l-8.43-10.38L842.1,232l-8.44-10.38L825.23,232l-8.44-10.38L808.36,232l-8.44-10.38L791.49,232l-8.44-10.38L774.62,232l-8.44-10.38v12.86",
    transform: "translate(-766.18 -221.63)",
    style: {"fill":"#fff"}
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", null, _toDisplayString(_ctx.date) + " " + _toDisplayString(_ctx.time), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "mobile-invoice-success__item"
      }, [
        _createElementVNode("div", {
          style: _normalizeStyle(item.titleStyle)
        }, _toDisplayString(item.title) + ":", 5),
        _createElementVNode("div", {
          style: _normalizeStyle(item.valueStyle),
          innerHTML: item.value
        }, null, 12, _hoisted_6)
      ]))
    }), 128)),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "bottom", {}, undefined, true)
    ]),
    _hoisted_9
  ]))
}